import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getAppPricing, upsertAppPricing } from 'api/appManager';
import { LIST_APP_DETAIL_PRICING_QUERY } from 'constants/QueryString';

export const useGetAppPricing = (query) => {
    const { data, isLoading, refetch, error, isFetching } = useQuery({
        queryKey: [LIST_APP_DETAIL_PRICING_QUERY, query],
        queryFn: async () => {
            try {
                const response = await getAppPricing(query);
                return response
            } catch (error) {
                throw error;
            }
        },
        enabled: !!query.appId,
    });

    return {
        data,
        isLoading,
        isFetching,
        refetch,
        error,
    };
};

export const useUpsertAppPricing = () => {
    const queryClient = useQueryClient();

    const {
        data,
        error,
        isError,
        isIdle,
        isPending,
        isLoading,
        isPaused,
        isSuccess,
        failureCount,
        failureReason,
        mutate,
        mutateAsync,
        reset,
        status,
        submittedAt,
        variables,
    } = useMutation({
        mutationFn: upsertAppPricing,
        onSuccess: (data) => {
            queryClient.removeQueries({ queryKey: [LIST_APP_DETAIL_PRICING_QUERY] });
        },
        onError: (error) => {
            console.error('Error', error);
            // Handle the error, show error message, etc.
        },
    });
    return {
        data,
        error,
        isError,
        isIdle,
        isPending,
        isLoading,
        isPaused,
        isSuccess,
        failureCount,
        failureReason,
        mutate,
        mutateAsync,
        reset,
        status,
        submittedAt,
        variables,
    };
};


